import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSyncAlt } from 'react-icons/fa';
import mainService from '../services/mainService';
import './MyOrders.css';

const formatCurrency = (value) => {
  const num = Number(value ?? 0);
  if (Number.isNaN(num)) return 'AED 0';
  return `AED ${num}`;
};

const MyOrders = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchBookings = async () => {
    try {
      setLoading(true);
      setError(null);

        const userDataStr = localStorage.getItem('userData');
        if (!userDataStr) {
          setError('Please login to view your orders.');
          setOrders([]);
          return;
        }
        const user = JSON.parse(userDataStr);
        const customerId = user.CustomerId || user.Id;
        if (!customerId) {
          setError('Customer information not found.');
          setOrders([]);
        return;
      }

        const data = await mainService.MyBookings(customerId);
        setOrders(data);
      } catch (err) {
        console.error('Failed to load bookings:', err);
        setError('Failed to load your orders. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

    fetchBookings();
  }, []);


  if (loading) {
    return (
      <div className="myorders-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner" />
            <p>Loading your orders...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="myorders-page">
        <div className="container">
          <div className="error-container">
            <p className="error-message">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="myorders-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">My Orders</h1>
         
        </div>

          <div className="orders-table-wrapper">
            <table className="orders-table">
              <thead>
                <tr>
                  <th>Booking #</th>
                  <th>Date</th>
                  <th>Delivery Date</th>
                  <th>Sub Total</th>
                  <th>Discount</th>
                  <th>Offer</th>
                  <th>Total</th>
                  <th>Delivery Charge</th>
                  <th>Final Price</th>
                  <th>Delivery Address</th>
                  <th>Status</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="12" className="empty-row">No orders found.</td>
                </tr>
              ) : (
                orders.map((r, index) => {
                  // Handle CustomerAddress object - extract address components
                  let addressText = '—';
                  if (r.CustomerAddress && typeof r.CustomerAddress === 'object') {
                    const addr = r.CustomerAddress;
                    const addressParts = [];
                    if (addr.Address) addressParts.push(addr.Address);
                    if (addr.Area) addressParts.push(addr.Area);
                    if (addr.Location) addressParts.push(addr.Location);
                    if (addr.POBox) addressParts.push(`P.O. Box: ${addr.POBox}`);
                    addressText = addressParts.length > 0 ? addressParts.join(', ') : '—';
                  } else if (r.CustomerAddress && typeof r.CustomerAddress === 'string') {
                    addressText = r.CustomerAddress;
                  }

                  return (
                    <tr key={r.Id || r.RefNo || index}>
                      <td>#{r.RefNo}</td>
                      <td>{r.Date ? new Date(r.Date).toLocaleDateString() : '—'}</td>
                      <td>{r.DeliveryDate ? new Date(r.DeliveryDate).toLocaleDateString() : '—'}</td>
                      <td>{formatCurrency(r.SubTotal)}</td>
                      <td>{formatCurrency(r.Discount)}</td>
                      <td>{formatCurrency(r.Offer)}</td>
                      <td>{formatCurrency(r.GrandTotal)}</td>
                      <td>{formatCurrency(r.TotalDeliveryCharge)}</td>
                      <td>{formatCurrency(r.FinalPrice)}</td>
                      <td className="address-cell" title={addressText}>{addressText}</td>
                      <td>
                        <span className={`status-badge status-${String(r.Status || r.status || '—').toLowerCase().replace(/\s+/g, '-')}`}>
                          {r.Status || r.status || '—'}
                      </span>
                    </td>
                    <td>
                        <button
                          className="view-btn"
                          onClick={() => navigate(`/my-orders?view=${encodeURIComponent(r.RefNo || r.Id)}`)}
                        >
                          View details
                      </button>
                    </td>
                  </tr>
                  );
                })
              )}
              </tbody>
            </table>
          </div>
      </div>
    </div>
  );
};

export default MyOrders;


